module.exports = __webpack_public_path__ + "img/weibinquAppImage.bd672d9f.png";